var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L12 4H8V0ZM7 4C7 4.5625 7.4375 5 8 5H12V14.5C12 15.3438 11.3125 16 10.5 16H1.5C0.65625 16 0 15.3438 0 14.5V1.5C0 0.6875 0.65625 0 1.5 0H7V4ZM8.5 13C8.75 13 9 12.7812 9 12.5C9 12.25 8.75 12 8.5 12H3.5C3.21875 12 3 12.25 3 12.5C3 12.7812 3.21875 13 3.5 13H8.5ZM8.5 11C8.75 11 9 10.7812 9 10.5C9 10.25 8.75 10 8.5 10H3.5C3.21875 10 3 10.25 3 10.5C3 10.7812 3.21875 11 3.5 11H8.5ZM9 8.5C9 8.25 8.75 8 8.5 8H3.5C3.21875 8 3 8.25 3 8.5C3 8.78125 3.21875 9 3.5 9H8.5C8.75 9 9 8.78125 9 8.5Z",
    fill: "#593DC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.5e19f648.svg";
export { ForwardRef as ReactComponent };